const env = process.env.REACT_APP_ENV;
const headers = {
  cache: 'no-cache',
  mode: 'cors'
};

const baseUrl = `https://2sqip5px7h.execute-api.ap-northeast-2.amazonaws.com/v1/${env}`;
export const document = () =>
  fetch(`${baseUrl}/kr_legal_riot_tos/entries`, headers)
    .then((payload) => payload && payload.json())
    .catch(() => Promise.resolve(null));

const section = ([element]) => ({
  title: element.section_title,
  logo: Object.keys(element)
    .filter((item) => item.includes('logo'))
    .map((name) => element[name].url)[0],
  legals: Object.keys(element)
    .map(
      (name) =>
        typeof element[name] === 'object' &&
        element[name] &&
        element[name][0] && {
          title: element[`${name}_title`],
          uri: `/${name.replace('_', '/')}`,
          docId: element[name][0].uid
        }
    )
    .filter((notNullable) => notNullable)
});

const categorizer = ({ entry }) => entry.modular_blocks.map((item) => section(Object.values(item)));

export const categories = () =>
  fetch(`${baseUrl}/kr_legal_main/entries/blta3d420588d163f2d`, headers)
    .then((payload) => payload && payload.json())
    .then((json) => categorizer(json))
    .catch((e) => Promise.resolve(null));

const generateMeta = ({ entries }, category) => entries.filter((entry) => entry.category_id === category)[0];

export const meta = (category) =>
  fetch(`${baseUrl}/legal_category/entries`, headers)
    .then((payload) => payload && payload.json())
    .then((json) => generateMeta(json, category))
    .catch(() => Promise.resolve(null));
